import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Image } from '$components/basic/Image';
import { Card } from '$components/basic/Card';

export interface ITile extends HTMLAttributes<HTMLDivElement> {
  readonly title: string;
  readonly children: React.ReactNode;
  readonly img: string;
}

function Tile({ title, children, img, className, ...props }: ITile): JSX.Element {
  return (
    <Card type={2} {...props} className={classNames('Tile', className)}>
      <Image provider="cloudinary" layout="fixed" src={img} alt={title} width="55" height="55" />
      <div>
        <p className="title">{title}</p>
        <div className="content">{children}</div>
      </div>
    </Card>
  );
}

export default Tile;
